import dedent from 'ts-dedent';
import { ColumnDataType, Provider, WorkflowComponentParamType } from '../types';
import { addColumns } from '../utils/schemas';
import { SelectWorkflowComponent } from './common/selectcomponent';
class XYCoords extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.xycoords',
            group: 'Spatial Accessors',
            title: 'ST X / ST Y',
            description: `
      This component creates a new table with additional columns containing X and Y coordinates
      of the geographies in the input table. This only applies to point geographies.
      `
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'geo',
                type: WorkflowComponentParamType.Column,
                title: 'Geo column',
                parent: 'source',
                dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
            }
        ]);
    }
    getInnerSql({ params, connection }) {
        switch (connection.type) {
            case Provider.BigQuery:
            case Provider.Snowflake:
            case Provider.Postgres:
            case Provider.Redshift:
                return dedent `SELECT *,
                  ST_X(${connection.processInputGeogColumn(params.geo)}) AS x_coord,
                  ST_Y(${connection.processInputGeogColumn(params.geo)}) AS y_coord
                FROM ${connection.quoteName(params.source)}`;
            case Provider.DatabricksRest:
                return dedent `SELECT /*+ REPARTITION(40) */
                  *,
                  ST_X(${connection.processInputGeogColumn(params.geo)}) AS x_coord,
                  ST_Y(${connection.processInputGeogColumn(params.geo)}) AS y_coord
                FROM ${connection.quoteName(params.source)}`;
            default:
                return null;
        }
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ columns }) {
        return addColumns(columns.source, [
            {
                name: 'x_coord',
                type: ColumnDataType.Number
            },
            {
                name: 'y_coord',
                type: ColumnDataType.Number
            }
        ]);
    }
}
export { XYCoords };
